import { useParams } from "react-router-dom";
// import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import AddSpecialtyModal from "../components/details/AddSpecialtyModal";
import {
  LdsButton,
  useLdsModal,
  LdsLink,
  LdsIcon,
} from "@elilillyco/ux-lds-react";
import {
  FETCH_OVERVIEW_TABLE_DATA,
  FETCH_COMMENTS_DATA,
} from "../store/details";
import { useEffect, useState } from "react";
import Comments from "../components/details/Comments";
import OverviewTable from "../components/details/OverviewTable";

import "../../src/assets/scss/details/details.scss";
import CLoader from "../components/shared/CLoader";

const Details = () => {
  const userRole = sessionStorage.getItem("role") || "";
  const { isModalOpen, setIsModalOpen } = useLdsModal();
  const [specialties, setSpecialties] = useState([]);
  const [selectedValues, setselectedValues] = useState([]);
  //visibleSpecialties contains specialties that are shown on details screen
  const [visibleSpecialties, setVisibleSpecialties] = useState({
    specialties: [],
  });
  const table = {
    thead: [
      "Specialty Code",
      "Specialty Description",
      "Incentivized",
      "Responsibility Code",
      "",
    ],
  };
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    loading,
    commentLoading,
    specialtyList,
    comments,
    responsibilityList,
    addspecialtyList,
    commentUserList,
  } = useSelector(({ details }) => details);

  const checkListStatus = () => {
    const userRole = sessionStorage.getItem("role")?.trim() || "";
    console.log("Details.js checkListStatus - userRole:", userRole, "list_status:", specialtyList?.list_status);
    
    if (
      Object.keys(specialtyList).length &&
      specialtyList.list_status !== "APPROVED" &&
      specialtyList.list_status !== "ARCHIVE" &&
      userRole !== "spclty_hub_viewer" &&
      userRole !== "spclty_hub_incentivized_approver"
    ) {
      return true;
    }
    // console.log("checkListStatus");
    return false;
  };
  const checkRoleSFMarketer = () => {
    const currentRole = sessionStorage.getItem("role")?.trim() || "";
    console.log("Details.js checkRoleSFMarketer - currentRole:", currentRole, "list_quarter:", specialtyList?.list_quarter);
    
    const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
    const isSalesforceList = !isMLRList;
    
    // Salesforce roles CANNOT add specialty codes to MLR lists
    if ((currentRole === "spclty_hub_hcp_sf_marketer" || currentRole === "spclty_hub_incentivized_approver") && isMLRList) {
      return false;
    }
    
    // MLR roles CANNOT add specialty codes to Salesforce lists
    if ((currentRole === "spclty_hub_hcp_marketer" || 
         currentRole === "spclty_hub_omnichannel_advisor" || 
         currentRole === "spclty_hub_mlr_reviewer" || 
         currentRole === "spclty_hub_mlr_approver") && isSalesforceList) {
      return false;
    }
    
    // Approver/Reviewer roles should not see Add Specialty button
    if (
      currentRole === "spclty_hub_mlr_approver" ||
      currentRole === "spclty_hub_mlr_reviewer" ||
      currentRole === "spclty_hub_incentivized_approver"
    ) {
      // console.log("checkRoleSFMarketer");
      return false;
    }
    
    // HCP SF Marketer cannot add specialty codes (only manages RC codes)
    if (currentRole === "spclty_hub_hcp_sf_marketer") {
      return false;
    }
    
    return true;
  };

  useEffect(() => {
    let tempData = JSON.parse(JSON.stringify(specialtyList));

    setVisibleSpecialties(tempData);
    setselectedValues([]);

    // NOTE: Department access check removed - users can VIEW all lists
    // Edit restrictions are enforced at the function level (hasDepartmentAccess() in OverviewTable.js)
  }, [specialtyList]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(FETCH_OVERVIEW_TABLE_DATA(id));
    dispatch(FETCH_COMMENTS_DATA(id));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSpecialties(addspecialtyList);
  }, [addspecialtyList]);

  function openAddSpcltyModal() {
    setIsModalOpen(true);
  }
  const [showAddedSpecialties, setShowAddedSpecialties] = useState([]);
  function handleSelectedSpecialty(data) {
    setShowAddedSpecialties(data);
    setselectedValues([]);
  }
  return (
    <div id="main">
      <section className="section">
        <div className="wrapper details-page">
          <div>
            <div className="content-block">
              {/* <h6>Details {id}</h6> */}
              {!loading && (
                <>
                  <div>
                    {/* <LdsLink href={`/overview?brand=${specialtyList.brand}`}>
                      <LdsIcon decorative name="CaretLeft" inline />
                      Back to Overview
                    </LdsLink> */}
                     <LdsLink href={`/overview`}>
                      <LdsIcon decorative name="CaretLeft" inline />
                      Back to Overview
                    </LdsLink>
                  </div>
                  <div className="mt-3">
                    <div>
                      <div className="row">
                        <div className="col">
                          <div>
                            <div>
                              <div className="row">
                                <div className="col-6">
                                  <h2>Details</h2>
                                </div>
                                {checkListStatus() && checkRoleSFMarketer() && (
                                  <div className="col-6 create-specialty">
                                    <div className="row-4">
                                      <span className="col-2 mrgn-rt">
                                        <LdsButton
                                          icon="Plus"
                                          iconPosition="before"
                                          classes="button-icon-left blue-btn"
                                          onClick={openAddSpcltyModal}
                                        >
                                          Add Speciality
                                        </LdsButton>
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <AddSpecialtyModal
                    isModalOpen={isModalOpen}
                    specialties={specialties}
                    setIsModalOpen={setIsModalOpen}
                    onDataUpdate={handleSelectedSpecialty}
                    visibleSpecialties={visibleSpecialties}
                    setVisibleSpecialties={setVisibleSpecialties}
                  ></AddSpecialtyModal>
                  <OverviewTable
                    bia_list={table}
                    visibleSpecialties={visibleSpecialties}
                    setVisibleSpecialties={setVisibleSpecialties}
                    responsibility_List={responsibilityList}
                    addspecialty_List={addspecialtyList}
                    showAddedSpecialties={showAddedSpecialties}
                    role={userRole}
                    selectedValues={selectedValues}
                    setselectedValues={setselectedValues}
                  />
                </>
              )}
            </div>
            <div className="content-block">
              {/* <h6>Details {id}</h6> */}
              {loading && <CLoader size={90} />}
            </div>
            <div className="content-block">
              {commentLoading ? (
                <CLoader size={90} />
              ) : (
                <Comments
                  commentList={comments}
                  specialtyList={specialtyList}
                  commentUserList={commentUserList}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Details;
